import React from "react";
import {SettingsDoc, User} from "../../types/Types";
import LocationComments from "./LocationComments";

interface Props {
    currentUser: User | undefined,
    usersMap: Map<string, User>
    settings: SettingsDoc
    likesMap: Map<string, boolean>
}

function MyLocation(props: Props) {
    return (
        <LocationComments 
            settings={props.settings} 
            usersMap={props.usersMap} 
            currentUser={props.currentUser}
            likesMap={props.likesMap}
        />);
}

export default MyLocation;